import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper } from '@mui/material';
import { DataGrid, GridToolbar, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './PanelDictamenesComponent.module.css'
import DictamenFiscalComponent from '../ComponentesDictamenes/DictamenFiscalComponent';
import DictamenJuridicoComponent from '../ComponentesDictamenes/DictamenJuridicoComponent';
import DictamenMarcarioComponent from '../ComponentesDictamenes/DictamenMarcarioComponent';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button } from '@mui/material';
import BotonVerDictamenesComponent from '../ComponentesDictamenes/BotonVerDictamenesComponent';
import { EliminarDictamenMarcario } from '../../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';

function PanelDictamenesComponent(props) {

    const solicitud = useSelector(store => store.UsuariosAtencionACliente.informacionClienteDictamen)
    const dispatch = useDispatch();

    let cadenaProductiva = ''
    for (const i in solicitud?.actividadcliente) {
        if (cadenaProductiva === '') cadenaProductiva += solicitud?.actividadcliente?.[i]?.tipoactividad?.actividad
        else cadenaProductiva += ',' + solicitud?.actividadcliente?.[i]?.tipoactividad?.actividad
    }

    let arregloCadena = cadenaProductiva.split(',')
    let combinacionCadena = ''
    let contador = 1
    for (const i in arregloCadena) {
        if (arregloCadena.length === 1) {
            combinacionCadena += arregloCadena[i]
        } else {
            if (arregloCadena.length === (contador + 1)) {
                combinacionCadena += arregloCadena[i] + ' y '
                contador++
            } else {
                combinacionCadena += arregloCadena[i]
                if (arregloCadena.length !== contador) {
                    combinacionCadena += ', '
                }
                contador++
            }

        }

    }

    let domicilioFiscal = ''
    for (const i in solicitud?.domiciliofiscalcliente) {
        const domicilio = solicitud?.domiciliofiscalcliente?.[i]
        if (domicilio?.numerointerior === "") {
            domicilioFiscal += 'Calle ' + domicilio?.calle + ' número ' + domicilio?.numeroexterior + ' Colonia ' + domicilio?.colonia
                + ', ' + domicilio?.localidad + ', ' + domicilio?.municipioalcaldia + ', ' + domicilio?.estado + ', C.P. ' + domicilio?.codigopostal + '. '
        } else {
            domicilioFiscal += 'Calle ' + domicilio?.calle + ' núm. exterior ' + domicilio?.numeroexterior + ', núm. interior ' + domicilio?.numerointerior + ', Colonia ' + domicilio?.colonia
                + ', ' + domicilio?.localidad + ', ' + domicilio?.municipioalcaldia + ', ' + domicilio?.estado + ', C.P. ' + domicilio?.codigopostal + '. '
        }
    }

    let marcasUnidas = solicitud?.marcascliente?.concat(solicitud?.marcasproductoconmezcalcliente);

    React.useEffect(async () => {
        if (solicitud?.dictamenmarcariocliente?.length > 0) {
            setDictamenMarcario(solicitud?.dictamenmarcariocliente)

        }
    }, [])

    const [dictamenmarcario, setDictamenMarcario] = useState([]);

    const agregardictamenmarcario = async (objectDictamen) => {

        //let filtroNuevo = dictamenmarcario?.filter?.(dictamen => dictamen?.id != null)
        const newField = { id: dictamenmarcario.length + 1, value: '' };
        setDictamenMarcario([...dictamenmarcario, newField]);
    };

    const handleChangeDictamenMarcario = (objectDictamen) => {

        let filtroEditar = dictamenmarcario?.find?.(dictamen => dictamen?.iddictamenmarcariocliente == objectDictamen?.iddictamenmarcariocliente)
        if (filtroEditar?.length == -1 || filtroEditar == undefined || filtroEditar == null) {
            let filtroDictamen = dictamenmarcario?.filter?.(dictamen => dictamen?.id == null)
            setDictamenMarcario(prev => [...filtroDictamen, objectDictamen])
        } else {
            const updatedFields = dictamenmarcario.map(dictamen => dictamen.iddictamenmarcariocliente === objectDictamen.iddictamenmarcariocliente ? { ...dictamen, objectDictamen } : dictamen);
            setDictamenMarcario(updatedFields);
        }
    };

    const deleteMarcario = async (objectDictamen) => {
        if (objectDictamen.id != null || objectDictamen.id != undefined) {
            const updatedFields = dictamenmarcario.filter(field => field.id != objectDictamen?.id);
            setDictamenMarcario(updatedFields);
        } else {
            await dispatch(EliminarDictamenMarcario(objectDictamen?.iddictamenmarcariocliente))
            const updatedFields = dictamenmarcario.filter(field => field.iddictamenmarcariocliente != objectDictamen?.iddictamenmarcariocliente);
            setDictamenMarcario(updatedFields);
        }
    }

    return (
        <div className='container' style={{}}>
            <div className='row text-center'>
                <div className={`mb-3 ${estilos.divInformacion} `}>
                    <div className='row'>
                        <div className="col-md-12 mt-4" >
                            <h3>Información de la Solicitud</h3>
                        </div>
                        <div className="col-md-7 mt-3 ps-4 text-start"><label><b>Nombre o Razón social: </b> {solicitud?.nombrerazonsocial} </label> </div>
                        <div className="col-md-3 mt-3 text-start"><label><b>RFC: </b> {solicitud?.rfc} </label> </div>
                        <div className="col-md-2 mt-3 pe-4 text-start"><label><b>Núm. de socio: </b> {solicitud?.numerosocio} </label> </div>

                        <div className="col-md-12 mt-3 ps-4 pe-4 text-start"><label><b>Representante legal: </b> {solicitud?.nombrerepresentantelegal} </label> </div>
                        <div className="col-md-12 mt-3 ps-4 pe-4 text-start"><label><b>Cadena productiva: </b> {combinacionCadena} </label> </div>

                        <div className="col-md-12 mt-3 mb-4 ps-4 pe-4 text-start"><label><b>Domicilio fiscal: </b> {domicilioFiscal} </label> </div>
                    </div>
                </div>


                <Accordion style={{ marginTop: '3px', backgroundColor: '#CE983A', borderRadius: '6px', marginBottom: '10px' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" style={{ textAlign: 'center' }} >
                        <Typography style={{ fontSize: 20, fontWeight: 'bold', fontFamily: 'Montserrat', margin: '0 auto' }}>DICTAMEN FISCAL</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <DictamenFiscalComponent />
                    </AccordionDetails>
                </Accordion>
                {!solicitud?.personafisica ?
                    <Accordion style={{ marginTop: '3px', backgroundColor: '#CE983A', borderRadius: '6px', marginBottom: '10px' }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header"  >
                            <Typography style={{ fontSize: 20, fontWeight: 'bold', fontFamily: 'Montserrat', margin: '0 auto' }}>DICTAMEN JURÍDICO</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <DictamenJuridicoComponent />
                        </AccordionDetails>
                    </Accordion>
                    : ''
                }


                <Accordion style={{ marginTop: '3px', backgroundColor: '#CE983A', borderRadius: '6px', marginBottom: '10px' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
                        <Typography style={{ fontSize: 20, fontWeight: 'bold', fontFamily: 'Montserrat', margin: '0 auto' }}>DICTAMEN MARCARIO</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {dictamenmarcario.map(field => (
                            <div key={field?.id}>
                                <DictamenMarcarioComponent api={{ deleteMarcario, handleChangeDictamenMarcario, agregardictamenmarcario, dictamenmarcario }}
                                    marcas={marcasUnidas} infodictamen={field} />
                                {/*<button onClick={() => deleteMarcario(field.id)} className='btn btn-danger' >Eliminar</button>*/}
                            </div>

                        ))}
                        <Button variant="contained" color="success" onClick={agregardictamenmarcario}>  Agregar </Button>
                    </AccordionDetails>
                </Accordion>


            </div>
        </div>
    )
}
export default withRouter(PanelDictamenesComponent)
